import React from 'react';
import { View, ViewProps } from 'react-native';

export type ViewSetTopLeftRef = {
  setTopLeft: (newValue: { top: number; left: number }) => void;
};

type Props = ViewProps & {
  initTopLeft: {
    top: number;
    left: number;
  };
  ref: React.Ref<ViewSetTopLeftRef>;
};

export const ViewSetTopLeft = ({
  ref,
  initTopLeft,
  ...props
}: React.PropsWithChildren<Props>) => {
  const [internalTopLeft, setInternalTopLeft] = React.useState<{
    top: number;
    left: number;
  }>(initTopLeft);

  React.useImperativeHandle(
    ref,
    () => ({
      setTopLeft: setInternalTopLeft,
    }),
    [],
  );

  React.useEffect(() => {
    setInternalTopLeft(initTopLeft);
  }, [initTopLeft]);

  return <View {...props} style={[props.style, internalTopLeft]} />;
};
